import React from "react";
import { useSelector } from "react-redux";

import { CategoryPageSkeleton } from "../../component/skeleton/CategoryPageSkeleton";
import { CancellationTablePage } from "./cancellationTable/cancellationTablePage";
import { CancellationFilterPage } from "./cancellationFilter/CancellationFilterPage";

import { selectCancellationState } from "../../store/cancellationFilterSlice";
import { selectCancellations, useGetCancellationsListQuery } from "../../services/cancellation/cancellationApiSlice";
import classes from "./cancellationListPage.module.css";

export const CancellationListPage = () => {
  const appliedFilters = useSelector(selectCancellationState);
  const { isSuccess } = useGetCancellationsListQuery(appliedFilters);

  const tableData = useSelector(selectCancellations);

  return isSuccess ? (
    <div className={classes.box}>
      <CancellationFilterPage/>
      <CancellationTablePage data={tableData} />
    </div>
  ) : (
    <CategoryPageSkeleton />
  );
};
